import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
// import { withStyles } from '@mui/material';
import { AppBar,useTranslate } from 'react-admin'
// import BackButton from './backButton'
import { List, ListButton, TopToolbar, Pagination,  Create, SimpleForm, TextInput, email, BooleanField,Link, Button, SelectInput, Datagrid, TextField, ReferenceField, EditButton, DeleteButton, ShowButton, DateField } from 'react-admin';

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const EditActions = ({ permissions, basePath, data, resource }) => (
    <TopToolbar>
        <ListButton resource='terms_and_condition_list' />
    </TopToolbar>
)

const ProductVaue = ({ record }) => {
    let recordValue = record && record.product_status && record.product_status[1] ? 'ON' : 'OFF';
    return recordValue;
}


export const TermsConditionsChangeLogList = ({ permissions, ...props }) => {
    console.log('ProductChangeLogList===================filterDefaultValues={{ sap_digital_order_id: props.id }}')
    const translate = useTranslate();

    return (
        <Scrollbars class="scroll-container">
            <List title={translate('resources.terms_and_condition_list.fields.terms_logs')}   sort={{ field: 'updated_at', order: 'DESC' }} actions={<EditActions/>}  {...props}>
                <Datagrid bulkActionButtons={false}>
                <TextField source="language_name" />
                    <TextField source="updated_by" sortable={false} />
                    <DateField  source="updated_at" showTime sortable={false}/>
                    {/* <TextField source="plant_name" label="Plant Name"  sortable={false}/> */}
                </Datagrid>
            </List>

        </Scrollbars>
    )
}

